module.exports = __webpack_public_path__ + "img/1542605233.35589281.jpg";